import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useEffectOnce } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { GenericResponse_$reflection, VesselRouteForm, VesselRoute_$reflection, VesselRouteForm_$reflection, RouteModule_RouteWithVessels_$reflection } from "./Shared/ApiDataTypes.js";
import { obj_type, array_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "./fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { singleton, cons, ofArray, empty } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { some, unwrap, map, defaultArg } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "./fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Auto_generateBoxedEncoder_437914C6, Auto_generateBoxedEncoderCached_437914C6 } from "./fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { fromString } from "./fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { arrayHash, equalArrays, compareArrays, defaultOf, equals, int32ToString, comparePrimitives, createObj, uncurry2 } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { mapFetchError } from "./Promises.js";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.5/Mui.fs.js";
import { Skeleton, CardActions, Typography, CardContent, CardMedia, Card, CardActionArea, DialogActions, Button, DialogContentText, Portal, DialogContent, Table, TableBody, IconButton, ButtonGroup, TableHead, TableRow, TextField, Alert, DialogTitle, Dialog, TableCell } from "@mui/material";
import { empty as empty_1, singleton as singleton_1, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { append as append_1, equalsWith, sortBy, map as map_1 } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { ErrorHandling_errorBanner, loadingIndicatorSmall, wrapTooltip } from "./ViewHelpers.js";
import { VesselRoute_FromId_Z524259A4, VesselRoute, VesselRoute__get_Id } from "./Shared/Shared.js";
import DirectionsBoat from "@mui/icons-material/DirectionsBoat";
import DirectionsBoatOutlined from "@mui/icons-material/DirectionsBoatOutlined";
import HourglassEmpty from "@mui/icons-material/HourglassEmpty";
import { RouterModule_encodeParts } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { toString as toString_1 } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import Delete from "@mui/icons-material/Delete";
import { Array_distinctBy } from "./fable_modules/fable-library-js.4.24.0/Seq2.js";

/**
 * component for assigning routes to a vessel
 */
export function AssignRouteForm(assignRouteFormInputProps) {
    let elems_14, children_7;
    const onClose = assignRouteFormInputProps.onClose;
    const vesselId = assignRouteFormInputProps.vesselId;
    const patternInput = reactApi.useState(undefined);
    const patternInput_1 = reactApi.useState(undefined);
    const setError = patternInput_1[1];
    const patternInput_2 = reactApi.useState("");
    const routeFilter = patternInput_2[0];
    useEffectOnce(() => {
        const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let pr_1, decoder, data_1, caseStrategy_2, extra_2;
            return ((pr_1 = ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(RouteModule_RouteWithVessels_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
                let properties_2;
                try {
                    const properties_3 = Helper_withProperties(empty(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/route-vessel", properties_3).then((_arg_1) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(RouteModule_RouteWithVessels_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_2) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })()))))), pr_1.then(mapFetchError))).then((_arg_3) => {
                const res_1 = _arg_3;
                if (res_1.tag === 1) {
                    setError(res_1.fields[0]);
                    return Promise.resolve();
                }
                else {
                    patternInput[1](res_1.fields[0]);
                    return Promise.resolve();
                }
            });
        }));
        pr_2.then();
    });
    const tryUpdateVesselRoute = (vr) => {
        const pr_5 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let pr_4, body_2, decoder_3, data_5, caseStrategy_11, extra_11;
            return ((pr_4 = ((body_2 = Auto_generateBoxedEncoder_437914C6(VesselRouteForm_$reflection(), undefined, undefined, undefined)(vr), (decoder_3 = Auto_generateBoxedDecoder_Z6670B51(VesselRoute_$reflection(), undefined, undefined), (data_5 = some(body_2), (caseStrategy_11 = undefined, (extra_11 = undefined, (() => {
                let properties_6;
                try {
                    const properties_3_1 = Helper_withProperties(singleton(new Types_RequestProperties(3, ["cors"])), (properties_6 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_5, empty()), 0)])]), defaultArg(map((data_1_2) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_11), unwrap(extra_11))(data_1_2))]), properties_6), data_5), properties_6)));
                    const pr_3 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/vessel-route", properties_3_1).then((_arg_4) => {
                        let response_3, decoder_1_2;
                        return ((response_3 = _arg_4, (decoder_1_2 = defaultArg(decoder_3, Auto_generateBoxedDecoderCached_Z6670B51(VesselRoute_$reflection(), unwrap(caseStrategy_11), unwrap(extra_11))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_3.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_3.text().then((_arg_5) => {
                            let matchValue_1;
                            return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_2), _arg_5), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_3])])))).then((_arg_1_2) => (Promise.resolve(_arg_1_2)))))))));
                    }))));
                    return pr_3.then(void 0, ((arg_1) => (new FSharpResult$2(1, [new FetchError(3, [arg_1])]))));
                }
                catch (exn_1) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_1])])))));
                }
            })())))))), pr_4.then(mapFetchError))).then((_arg_6) => {
                const res_3 = _arg_6;
                if (res_3.tag === 0) {
                    onClose(res_3.fields[0]);
                    return Promise.resolve();
                }
                else {
                    setError(res_3.fields[0]);
                    return Promise.resolve();
                }
            });
        }));
        pr_5.then();
    };
    const smallCell = (c) => MuiHelpers_createElement(TableCell, [["size", "small"], ["children", c]]);
    const children_8 = singleton(MuiHelpers_createElement(Dialog, [["open", true], ["onClose", (_arg_8, v) => {
        onClose(undefined);
    }], ["PaperProps", {
        style: {
            width: 100 + "%",
        },
    }], (elems_14 = [MuiHelpers_createElement(DialogTitle, [["children", "Legg til samband"]]), (children_7 = toList(delay(() => {
        let matchValue_2, e_1;
        return append((matchValue_2 = patternInput_1[0], (matchValue_2 != null) ? ((e_1 = matchValue_2, singleton_1(MuiHelpers_createElement(Alert, [["severity", "warning"], ["children", reactApi.Children.toArray([e_1])]])))) : (empty_1())), delay(() => {
            let elems_2, elems_1;
            const matchValue_3 = patternInput[0];
            if (matchValue_3 != null) {
                const r = matchValue_3;
                return append(singleton_1(createElement("div", createObj(ofArray([["style", {}], (elems_2 = [MuiHelpers_createElement(TextField, [["size", "small"], ["variant", "outlined"], ["fullWidth", true], ["label", "Søk i samband"], ["onChange", (e_2) => {
                    patternInput_2[1](e_2.target.value);
                }], ["defaultValue", routeFilter]])], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                    let children_6, children_1, children, children_5, loweredFilter;
                    return singleton_1((children_6 = ofArray([(children_1 = singleton((children = ofArray([smallCell("Navn"), smallCell("Nummer"), MuiHelpers_createElement(TableCell, [["size", "small"], ["align", "center"], ["children", "Alloker"]])]), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children))]]))), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children_1))]])), (children_5 = map_1((x_7) => {
                        let elems_10, elems_9, elems_8, elems_5, props_10, elems_6, props_13, elems_7, props_16;
                        return MuiHelpers_createElement(TableRow, [["className", "striped-table-row"], (elems_10 = [smallCell(x_7.Route), smallCell(x_7.RouteNumber), MuiHelpers_createElement(TableCell, [["size", "small"], ["align", "center"], (elems_9 = [MuiHelpers_createElement(ButtonGroup, [["color", "primary"], (elems_8 = [wrapTooltip("Hovedsamband", MuiHelpers_createElement(IconButton, [["onClick", (_arg_9) => {
                            tryUpdateVesselRoute(new VesselRouteForm(vesselId, x_7.RouteId, VesselRoute__get_Id(new VesselRoute(0, []))));
                        }], (elems_5 = [(props_10 = {}, react.createElement(DirectionsBoat, props_10))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])), wrapTooltip("Reservesamband", MuiHelpers_createElement(IconButton, [["onClick", (_arg_10) => {
                            tryUpdateVesselRoute(new VesselRouteForm(vesselId, x_7.RouteId, VesselRoute__get_Id(new VesselRoute(2, []))));
                        }], (elems_6 = [(props_13 = {}, react.createElement(DirectionsBoatOutlined, props_13))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])), wrapTooltip("Reservert samband", MuiHelpers_createElement(IconButton, [["onClick", (_arg_11) => {
                            tryUpdateVesselRoute(new VesselRouteForm(vesselId, x_7.RouteId, VesselRoute__get_Id(new VesselRoute(1, []))));
                        }], (elems_7 = [(props_16 = {}, react.createElement(HourglassEmpty, props_16))], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])], ["children", reactApi.Children.toArray(Array.from(elems_9))])])], ["children", reactApi.Children.toArray(Array.from(elems_10))])]);
                    }, sortBy((x_5) => x_5.Route.toLocaleLowerCase(), (routeFilter.trim().length > 0) ? ((loweredFilter = routeFilter.trim().toLocaleLowerCase(), r.filter((x_4) => {
                        if (x_4.Route.toLocaleLowerCase().indexOf(loweredFilter) >= 0) {
                            return true;
                        }
                        else {
                            return x_4.RouteNumber.toLocaleLowerCase().indexOf(loweredFilter) >= 0;
                        }
                    }))) : r, {
                        Compare: comparePrimitives,
                    })), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children_5))]]))]), MuiHelpers_createElement(Table, [["children", reactApi.Children.toArray(Array.from(children_6))]])));
                }));
            }
            else {
                return singleton_1(createElement("div", createObj(ofArray([["style", {}], (elems_1 = [loadingIndicatorSmall()], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
            }
        }));
    })), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children_7))]]))], ["children", reactApi.Children.toArray(Array.from(elems_14))])]));
    return MuiHelpers_createElement(Portal, [["children", reactApi.Children.toArray(Array.from(children_8))]]);
}

export function RemoveRouteForm(removeRouteFormInputProps) {
    let elements_2, children, children_1;
    const onClose = removeRouteFormInputProps.onClose;
    const vesselRouteType = removeRouteFormInputProps.vesselRouteType;
    const routeId = removeRouteFormInputProps.routeId;
    const vesselId = removeRouteFormInputProps.vesselId;
    const patternInput = reactApi.useState(false);
    const setProcessing = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const setErrMsg = patternInput_1[1];
    return MuiHelpers_createElement(Dialog, [["open", true], ["onClose", (_arg_4, v) => {
        onClose(false);
    }], (elements_2 = [MuiHelpers_createElement(DialogTitle, [["children", "Fjern samband fra fartøy"]]), (children = ofArray([MuiHelpers_createElement(DialogContentText, [["children", "Er du sikker på at du ønsker å fjerne dette sambandet fra fartøyet?"]]), ErrorHandling_errorBanner(patternInput_1[0], () => {
        setErrMsg(undefined);
    })]), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children))]])), (children_1 = toList(delay(() => (patternInput[0] ? singleton_1(loadingIndicatorSmall()) : append(singleton_1(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "outlined"], ["children", "Avbryt"], ["onClick", (_arg_6) => {
        onClose(false);
    }]])), delay(() => singleton_1(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "contained"], ["color", "primary"], ["children", "Fjern"], ["onClick", (_arg_7) => {
        const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let body, decoder, data_1, caseStrategy_3, extra_3;
            setProcessing(true);
            const req = new VesselRouteForm(vesselId, routeId, vesselRouteType);
            return ((body = Auto_generateBoxedEncoder_437914C6(VesselRouteForm_$reflection(), undefined, undefined, undefined)(req), (decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined), (data_1 = some(body), (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
                let properties_2;
                try {
                    const properties_3 = Helper_withProperties(singleton(new Types_RequestProperties(3, ["cors"])), (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/vessel-remove-route", properties_3).then((_arg) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })())))))).then((_arg_2) => {
                const res = _arg_2;
                if (res.tag === 0) {
                    const r = res.fields[0];
                    if (r.Result === "success") {
                        onClose(true);
                        return Promise.resolve();
                    }
                    else {
                        setErrMsg(r.Message);
                        setProcessing(false);
                        return Promise.resolve();
                    }
                }
                else {
                    setProcessing(false);
                    setErrMsg("Kunne ikke fjerne samband fra fartøy. Vennligst prøv igjen senere.");
                    return Promise.resolve();
                }
            });
        }));
        pr_1.then();
    }]]))))))), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_1))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
}

export function vesselRouteCard(isVessel, canEdit, v, toggleDelete) {
    let elems_3, elems_2;
    const vesselRoute = VesselRoute_FromId_Z524259A4(v.VesselRouteType);
    return MuiHelpers_createElement(CardActionArea, [["href", isVessel ? RouterModule_encodeParts(ofArray(["routes", int32ToString(v.RouteId), "info"]), 1) : RouterModule_encodeParts(ofArray(["vessels", int32ToString(v.VesselId), "info"]), 1)], ["style", {
        width: 180,
        height: 210,
        margin: 5,
        borderRadius: 4,
    }], (elems_3 = [MuiHelpers_createElement(Card, [["style", {
        width: 180,
        height: 210,
    }], (elems_2 = toList(delay(() => {
        let matchValue;
        return append(singleton_1(MuiHelpers_createElement(CardMedia, [["style", {
            height: 120,
            backgroundSize: "contain",
        }], ["alt", isVessel ? (`Bilde av sambandet ${v.Route}`) : (`Bilde av fartøyet ${v.Vessel}`)], ["image", isVessel ? "/images/route_default.jpg" : ((matchValue = v.VesselImageId, (matchValue != null) ? (`/api/vessel/image/${matchValue}/thumbnail`) : "/images/FerryPictureDefaultThumbnail.png"))]])), delay(() => {
            let elements;
            return append(singleton_1(MuiHelpers_createElement(CardContent, [["style", {
                padding: ((0 + "px ") + 16) + "px",
            }], (elements = [MuiHelpers_createElement(Typography, [["style", {
                whiteSpace: "nowrap",
                overflowX: "hidden",
                textOverflow: "ellipsis",
            }], ["variant", "h6"], ["children", isVessel ? v.Route : v.Vessel]]), MuiHelpers_createElement(Typography, [["variant", "caption"], ["component", "p"], ["children", toString_1(vesselRoute)]])], ["children", reactApi.Children.toArray(Array.from(elements))])])), delay(() => {
                let elements_1, props_5;
                return canEdit ? singleton_1(MuiHelpers_createElement(CardActions, [(elements_1 = [wrapTooltip("Fjern", MuiHelpers_createElement(IconButton, [["size", "small"], ["children", (props_5 = {}, react.createElement(Delete, props_5))], ["onClick", (e) => {
                    e.preventDefault();
                    toggleDelete(v);
                }]]))], ["children", reactApi.Children.toArray(Array.from(elements_1))])])) : empty_1();
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])], ["children", reactApi.Children.toArray(Array.from(elems_3))])]);
}

function drawVesselRoutes(canEdit, x, toggleDelete) {
    let testExpr, elems;
    if (x != null) {
        if ((testExpr = x, !equalsWith(equals, testExpr, defaultOf()) && (testExpr.length === 0))) {
            return createElement("p", {
                children: ["Ingen samband registrert på dette fartøyet"],
            });
        }
        else {
            const x_2 = x;
            return createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexWrap: "wrap",
                gap: 10 + "px ",
            }], (elems = [map_1((v_1) => vesselRouteCard(true, canEdit, v_1, toggleDelete), sortBy((v) => [v.VesselRouteType, v.Vessel], x_2, {
                Compare: compareArrays,
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
        }
    }
    else {
        return MuiHelpers_createElement(Skeleton, [["style", {
            borderRadius: 5,
        }], ["variant", "rectangular"], ["width", 100 + "%"], ["height", 200]]);
    }
}

/**
 * Component used in vessel view to load, display and edit connected routes
 */
export function VesselRoutes(vesselRoutesInputProps) {
    const vesselId = vesselRoutesInputProps.vesselId;
    const canEdit = vesselRoutesInputProps.canEdit;
    const patternInput = reactApi.useState(undefined);
    const setRoutes = patternInput[1];
    const routes = patternInput[0];
    const patternInput_1 = reactApi.useState(false);
    const setAssignForm = patternInput_1[1];
    const patternInput_2 = reactApi.useState(undefined);
    const setRemoveForm = patternInput_2[1];
    useEffectOnce(() => {
        const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let decoder, data_1, caseStrategy_2, extra_2;
            return ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(VesselRoute_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
                let properties_2;
                try {
                    const properties_3 = Helper_withProperties(empty(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`/api/route/for-vessel/${vesselId}`, properties_3).then((_arg) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(VesselRoute_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })()))))).then((_arg_2) => {
                const res = _arg_2;
                if (res.tag === 0) {
                    setRoutes(res.fields[0]);
                    return Promise.resolve();
                }
                else {
                    return Promise.resolve();
                }
            });
        }));
        pr_1.then();
    });
    const xs_1 = toList(delay(() => {
        let elems;
        return append(singleton_1(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        }], (elems = toList(delay(() => append(singleton_1(MuiHelpers_createElement(Typography, [["variant", "h6"], ["children", "Samband"]])), delay(() => (canEdit ? singleton_1(MuiHelpers_createElement(Button, [["variant", "contained"], ["color", "primary"], ["children", "Legg til samband"], ["onClick", (_arg_4) => {
            setAssignForm(true);
        }]])) : empty_1()))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => append(patternInput_1[0] ? singleton_1(createElement(AssignRouteForm, {
            vesselId: vesselId,
            onClose: (x_2) => {
                let f1_1, array;
                if (x_2 != null) {
                    setRoutes(map((f1_1 = ((array = [x_2], (array_1) => append_1(array, array_1))), (arg_1) => Array_distinctBy((v) => [v.RouteId, v.VesselId, v.VesselRouteType], f1_1(arg_1), {
                        Equals: equalArrays,
                        GetHashCode: arrayHash,
                    })), routes));
                    setAssignForm(false);
                }
                else {
                    setAssignForm(false);
                }
            },
        })) : empty_1(), delay(() => {
            let matchValue_1, rf;
            return append((matchValue_1 = patternInput_2[0], (matchValue_1 != null) ? ((rf = matchValue_1, singleton_1(createElement(RemoveRouteForm, {
                vesselId: rf.VesselId,
                routeId: rf.RouteId,
                vesselRouteType: rf.VesselRouteType,
                onClose: (didDelete) => {
                    let array_3;
                    if (!didDelete) {
                        setRemoveForm(undefined);
                    }
                    else {
                        if (routes != null) {
                            setRoutes((array_3 = routes, array_3.filter((x_4) => !(((x_4.VesselId === rf.VesselId) && (x_4.RouteId === rf.RouteId)) && (x_4.VesselRouteType === rf.VesselRouteType)))));
                        }
                        setRemoveForm(undefined);
                    }
                },
            })))) : (empty_1())), delay(() => singleton_1(drawVesselRoutes(canEdit, routes, (arg_2) => {
                setRemoveForm(arg_2);
            }))));
        }))));
    }));
    return react.createElement(react.Fragment, {}, ...xs_1);
}

//# sourceMappingURL=VesselRoute.js.map
